/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab.ts";
import { courseRegistrationManagementSelectiveProcessViewModelSchema } from "../courseRegistrationManagementSelectiveProcessViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab200Schema =
  z.lazy(
    () => courseRegistrationManagementSelectiveProcessViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabQueryResponse>;
